module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAYAAAAVMmT4AAAAk0lEQVQYlXXKsU3DABRF0fPjOK6wMgYFMvMYiTABFUMkA1BRswY1HVuQHlIhZD8aCwkEp7y61W+3D13bfkzTdOs/VfdF23Rd97Juml24wNMf417VeZK7leRVcoVLVfvfYxjmZAzH1ZLfJCMGVYelHTCEEe9Qfd/rNhvTPMOZqkes8TlzjRNIrPx0kuzC88zN97j4Ao1NMbBXbZc2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account_dropdown_arrow.png
// module id = 936
// module chunks = 0 1 2 3 4 5 6 7